import {styled} from '@mui/material';
import React from 'react';

const Container = styled('div')(({theme}) => ({
  borderBottom: `2px solid ${theme.palette.grey['100']}`,
  borderTop: `2px solid ${theme.palette.grey['100']}`,
  display: 'flex',
  flex: 1,
  width: '100%',

  '& > span': {
    alignItems: 'center',
    display: 'flex',
    flex: 0,
    padding: `0 ${theme.spacing(2)}`,
  }
}));

const Statuses = styled('ul')(({theme}) => ({
  display: 'flex',
  flex: 1,
  listStyle: 'none',
  margin: 0,
  padding: `0 ${theme.spacing(2)} 0 0`,
}));

const Status = styled('li')(({theme}) => ({
  borderLeft: `2px solid ${theme.palette.grey['100']}`,
  color: 'var(--status-colour)',
  cursor: 'pointer',
  fontWeight: '700',
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,

  '&:last-of-status': {
    borderRight: `2px solid ${theme.palette.grey['100']}`,
  },

  '&.selected': {
    background: 'var(--status-colour)',
    color: theme.palette.common.white,
  }
}));

// noinspection JSValidateTypes
const Filter = ({statuses, status, onChangeStatus}) => (
  <Container>
    <span>Displaying:</span>
    <Statuses>
      {statuses.map(({title, key, colour}, index) => (
        <Status
          key={index}
          className={status === key ? 'selected' : ''}
          style={{'--status-colour': colour}}
          onClick={() => status === key ? null : onChangeStatus(key)}
        >
          {title}
        </Status>
      ))}
    </Statuses>
  </Container>
);

export default Filter;
